import { Col, Drawer as AntdDrawer, type DrawerProps as AntdDrawerProps, Row } from 'antd';
import type React from 'react';
import { useEffect, useState } from 'react';

import type { VoidFnType } from '@/types/common';

interface DrawerProps extends AntdDrawerProps {
  children: React.ReactNode;
  onClose: VoidFnType;
  footer?: (onClose: VoidFnType) => React.ReactNode;
  extra?: React.ReactNode;
}

export const Drawer = ({
  title,
  placement = 'right',
  children,
  closable = true,
  width = 500,
  footer,
  extra,
  ...props
}: DrawerProps) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(props.visible);
  }, [props.visible]);

  const afterVisibleChange = (visibleValue: boolean) => {
    if (!visibleValue) {
      props.onClose();
    }
  };

  const onClose = () => {
    setVisible(false);
  };

  const drawerTitle =
    extra != null ? (
      <Row justify="space-between" align="middle" style={{ width: '100%', paddingRight: 24 }}>
        <Col>{title}</Col>
        <Col flex="none">{extra}</Col>
      </Row>
    ) : (
      title
    );

  return (
    <AntdDrawer
      afterVisibleChange={afterVisibleChange}
      title={drawerTitle}
      placement={placement}
      closable={closable}
      onClose={onClose}
      visible={visible}
      width={width}
      footer={footer?.(onClose)}
    >
      {children}
    </AntdDrawer>
  );
};
